<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refDataGrid'
          :data-source='dataGridList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="true"
          key-expr="입고업체"
          @toolbar-preparing='onToolbarPreparing'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="exportTitle"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumn
            :allowEditing='true'
            caption="거래처명"
            data-field="거래처명"
          >
          </DxColumn>
          <DxColumn
            caption="구입금액"
            data-field="구입금액"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            caption="원자재 코일"
            alignment="center"
          >
            <DxColumn
              caption="사급금액"
              data-field="사급금액"
              format='#,##0'
              dataType="number"
            >
            </DxColumn>
            <DxColumn
              caption="스크랩사급"
              data-field="스크랩사급"
              format='#,##0'
              dataType="number"
            >
            </DxColumn>
              <DxColumn
              caption="소계"
              :calculate-cell-value="calcPrice"
              format='#,##0'
              dataType="number"
            >
            </DxColumn>
          </DxColumn>
          <DxColumn
            caption="정산금액(구입-사급)"
            data-field="정산금액"
            :calculate-cell-value="calcPriceDiff"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            caption="비고"
            width="200"
          >
          </DxColumn>
          <DxMasterDetail
            :enabled="true"
            template="purchaseDetailTemplate"
          />
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="거래처명"
              display-format="{0} (건)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="구입금액"
              display-format="{0} (원)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="사급금액"
              display-format="{0} (원)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="스크랩사급"
              display-format="{0} (원)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="소계"
              display-format="{0} (원)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="정산금액"
              display-format="{0} (원)"
            />
          </DxSummary>
          <template #purchaseDetailTemplate="{ data: item }">
            <RawMaterialsInOutDetailTemp
              :item=item
              :thisYear="thisYear"
              :thisMonth="thisMonth"
              :isYear="yearToggle"
            />
          </template>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
          <template #scrap-price-date>
            <div class="toolbar-label" style='font-size:1.2rem;margin-left:10px;'>
              <b>  스크랩단가: {{scrapPrice}}원</b>
            </div>
          </template>
        </dx-data-grid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxTotalItem, DxMasterDetail,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel } from 'devextreme-vue/data-grid'
import AppLib from '../../share/AppLib'
import RawMaterialsInOutDetailTemp from './RawMaterialsInOutDetailTemp'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '업체별 구매/사급 내역'
        }
      ],
      today: null,
      scrapPrice: null,
      thisYear: null,
      thisMonth: null,
      monthArray: [],
      yearArray: [],
      selectedMonth: null,
      // 업체별 구매/사급 내역
      dataGridList: null,
      yearToggle: false

    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxDataGrid,
    DxMasterDetail,
    RawMaterialsInOutDetailTemp
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.today = AppLib.getToday()
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ 'name': i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ 'name': i + '월', value: '' + i })
      }
    }
    this.refreshDataGrid(false)
    this.refreshScrapPrice()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcPrice (row) {
      return (row.사급금액 + row.스크랩사급)
    },
    calcPriceDiff (row) {
      return row.구입금액 - (row.사급금액 + row.스크랩사급)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.thisYear = args.value
              this.refreshDataGrid(false)
              this.refreshScrapPrice()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: (args) => {
              this.thisMonth = args.value
              this.refreshDataGrid(false)
              this.refreshScrapPrice()
            }
          }
        },
        {
          location: 'before',
          template: 'scrap-price-date'
        },
        {
          location: 'after',
          widget: 'dxCheckBox',
          options: {
            value: this.yearToggle,
            text: '년도별 합계',
            onValueChanged: (args) => {
              this.yearToggle = args.value
              this.refreshDataGrid(this.yearToggle)
            }
          }
        }
      )
    },
    refreshDataGrid (yearToggle) {
      let param
      if (yearToggle === true) {
        this.exportTitle = `${this.thisYear}년-구매-사급내역서`
        let endDate = AppLib.calcDateFromFormat(`${this.thisYear}-12-31`, 1)
        param = {
          fromDate: `${this.thisYear}-01-01`,
          toDate: `${endDate}`
        }
      } else {
        this.exportTitle = `${this.thisYear}년${this.thisMonth}월-구매-사급내역서`
        let endDate = `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
        endDate = AppLib.calcDateFromFormat(endDate, 1)
        param = {
          fromDate: `${this.thisYear}-${this.thisMonth}-01`,
          toDate: `${endDate}`
        }
      }
      this.$_sp.runNoEncodeFindProc('spFindAllMaterialsInOutSummaryByDateWith', param)
        .then((data) => {
          this.dataGridList = this.$_sp.MakeModel(data)
          console.log(this.dataGridList)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshScrapPrice () {
      this.$_sp.runNoEncodeFindProc('spFindAllScrapPriceByDate', { date: `${this.thisYear}-${this.thisMonth}-01` })
        .then((data) => {
          this.scrapPrice = this.$_sp.MakeModel(data)[0].가격
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
